import React, { FC, useEffect, useState } from "react";

import { differenceInYears } from "date-fns";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormControl, FormLabel } from "@mui/material";

import { DateInput, FieldError, TextInput } from "@/components/atoms";
import { RefRadioButtonGroup, RefSelectInput } from "@/components/molecules";

import { FormType } from "../../utils";

const DriversLicense: FC = () => {
    const {
        formState: { errors },
        watch,
        control,
        setValue,
    } = useFormContext<FormType>();
    const { t } = useTranslation();
    const hasDriversLicense = watch("driversLicense") === "yes";
    const birthdate = watch("birthdate");
    const [isEditable, setIsEditable] = useState(true);

    useEffect(() => {
        if (differenceInYears(new Date(), birthdate) < 16) {
            setValue("driversLicense", "no");
            setIsEditable(false);
        } else {
            setIsEditable(true);
        }
    }, [birthdate]);

    return (
        <>
            <FormControl error={Boolean(errors.driversLicense)}>
                <FormLabel className="label" htmlFor="driversLicense">
                    {t("AddFamilyMember.DriverLicense.Label")}
                </FormLabel>
                <RefRadioButtonGroup name="driversLicense" control={control} table="yesNo" disabled={!isEditable} />
                <FieldError error={errors.driversLicense} />
            </FormControl>
            {hasDriversLicense && (
                <>
                    <TextInput
                        name="driversLicenseNumber"
                        label={t("Common.Number")}
                        LabelProps={{ className: "mt10" }}
                        autoComplete="off"
                        control={control}
                    />
                    <DateInput
                        name="driversLicenseIssueDate"
                        disableFuture
                        control={control}
                        label={t("AddFamilyMember.DriverLicense.IssueDate")}
                    />
                    <RefSelectInput name="driversLicenseType" control={control} table="driversLicenseType" />
                    <RefSelectInput
                        name="driversLicenseIssueCountry"
                        control={control}
                        label={t("AddFamilyMember.DriverLicense.IssueCountry")}
                        table="country"
                    />
                </>
            )}
        </>
    );
};

export default DriversLicense;
